import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {IonContent, NavController, PopoverController} from "@ionic/angular";
import {ModelProvider, ResInterface} from "../../../framework/providers/modelProvider/ModelProvider";
import {ActivatedRoute, NavigationExtras} from "@angular/router";
import {AppConfig} from "../../../core/conf/main";
import {ModelToolsProvider} from "../../../framework/providers/model-tools/model-tools";
import {CalendarComponent} from "../components/calendar/calendar.component";
import {BusinessService} from "../../../core/services/BusinessService";
import {AdminService} from "../../../core/services/AdminService";
import {Events} from "../../../framework/providers/events";

import {Chart, LineController, LineElement, PointElement} from 'chart.js';
import {
    LinearScale,
    BarElement,
    BarController,
    CategoryScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip
} from 'chart.js';
import set = Reflect.set;
import {SelectBarComponent} from "../components/select-bar/select-bar.component";
import {AppDataService} from 'src/core/services/AppDataService';
import {OrderService} from "../../../core/services/OrderService";

@Component({
    selector: 'app-taarif',
    templateUrl: './taarif.page.html',
    styleUrls: ['./taarif.page.scss'],
})
export class TaarifPage implements OnInit, OnDestroy {
    @ViewChildren("graphs", {read: ElementRef}) graphs: QueryList<ElementRef>;
    // @ViewChild("barCanvas1", {'static': true}) barCanvas1: ElementRef;
    // @ViewChild("barCanvas2", {'static': true}) barCanvas2: ElementRef;
    // @ViewChild("barCanvas3", {'static': true}) barCanvas3: ViewChild;
    // @ViewChild(IonContent, {'static': true}) ionContent: IonContent;

    ready = false;
    tableData;
    currentOpenSection;
    exTableData;
    exTableData2;
    calendarModelsObj = {};

    myprefix = "selectTablePrefix3" + Math.floor(Math.random() * Math.floor(1000));

    constructor(public events: Events,
                public popoverCtrl: PopoverController,
                public business: BusinessService,
                public navCtrl: NavController,
                public orderService: OrderService,
                public modelProvider: ModelProvider,
                public appData: AppDataService,
                public modelTools: ModelToolsProvider,
                public businessService: BusinessService,
                public adminService: AdminService,
                public route: ActivatedRoute) {
        Chart.register(PointElement, LineController, LineElement, LinearScale, BarElement, BarController, CategoryScale, Decimation, Filler, Legend, Title, Tooltip);
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        let filters = {'ordering': '-id', 'type': 'moving', 'name': 'taarif', 'modelOffset': 0, 'modelLimit': 20};
        let me = this;
        this.modelProvider.list('report', filters).then(function (data: any) {
            me.exTableData = data.models[0].data.finalResReport;
            me.exTableData2 = JSON.parse(JSON.stringify(data.models[0].data.finalResReport));
            me.loadDashboard();
        });
    }

    ngOnDestroy(): void {
        this.ready = false;
    }

    setCurrentSection(current) {
        this.currentOpenSection = null;

        let me = this;
        setTimeout(function () {
            me.currentOpenSection = current;
        }, 1);
    }

    loadDashboard() {
        let me = this;
        let filters = {
            'ordering': '-id', 'type': 'moving', 'getDashboard': 1,
            'name': 'taarif', 'modelOffset': 0, 'modelLimit': 20
        };
        this.modelProvider.list('report', filters).then(function (data: any) {
            let models = data.models;
            let tableData;
            if (models && models.length > 0) //if error occured models len is 0.
            {
                tableData = models[0].data.finalResReport;

                me.tableData = tableData;
                me.exTableData = tableData;

                me.ready = true;
                me.adminService.dashboardData = tableData;

                me.currentOpenSection = tableData['homePage'][0]['main']['homeData'];
                // me.businessService.setAdminData(tableData);

                me.loadCalendar();
            }
        });

    }


    loadCalendar() {
        if (this.exTableData['calendarModels']) {
            let calendarModels = this.exTableData['calendarModels'];
            this.calendarModelsObj = {}
            for (let k in calendarModels) {
                this.calendarModelsObj[calendarModels[k]['name']] = calendarModels[k];
            }
        }
    }

    //lables = ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"]
    //data = [12, 19, 3, 5, 2, 3]
    setChart(barElement, labales, data, type, dcolors = null) {
        // if (this.barChart) {
        //     this.barChart.clear();
        // }

        let colors = [];
        let colorsData = {
            "primary": "rgba(56, 128, 255, 0.2)",
            "danger": "rgba(245, 61, 61, 0.2)",
            "warning": "rgba(255, 206, 0, 0.2)",
            "secondary": "rgba(12, 209, 232, 0.2)",
            "dark": "rgba(34, 34, 34, 0.2)",
            "success": "rgba(16, 220, 96, 0.2)"
        };

        for (let key in colorsData) {
            colors.push(colorsData[key]);
        }

        if (dcolors) {
            for (let key in dcolors) {
                if (dcolors[key] != -1) {
                    colors[key] = colorsData[dcolors[key]];
                }
            }
        }

        let datasets = [];
        if (type == 'radar') {
            for (let i in data) {
                datasets.push({
                    'label': i,
                    'data': data[i]
                })
            }
        } else {
            datasets = [
                {
                    label: "",
                    data: data,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }
            ];
        }

        //
        //         type: 'horizontalBar',
        new Chart(barElement.nativeElement, {
            type: type,
            data: {
                labels: labales,
                datasets: datasets
            },
            options: {
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                }
            }
        });
    }

    async presentSelectBar(myEvent, type, isbig = false) {
        const popover = await this.popoverCtrl.create({
            component: SelectBarComponent,
            componentProps: {
                'prefix': 'aaaa',
                'exTableData': this.exTableData,
                'sectionName': null,
                'type': type
            },
            event: myEvent,
            animated: true,
            showBackdrop: true,
            cssClass: 'note-popover icenter-popover ' + (isbig ? 'bigger-popover' : 'smaller-popover')
        });
        return await popover.present();
    }

    openCustomModel(sectionName) {
        ////console.log'open custom model: ', sectionName);
        let params = {
            'sectionName': sectionName
        };

        let navigationExtras: NavigationExtras = {
            queryParams: params
        };

        this.navCtrl.navigateForward('admin-model/' + sectionName, navigationExtras);
    }

    //update server it needs to update changes.
    updateData() {
        let filters = {'ordering': '-id', 'type': 'moving', 'name': 'taarif', 'modelOffset': 0, 'modelLimit': 20};
        filters['editedSections'] = [];
        filters['sectionName'] = '';
        filters['updateData'] = true;
        filters['updateModelClasses'] = true;
        this.modelProvider.customPost('saveDataReport', [], filters, true).then((data: any) => {
            // this.events.publish('refresh_request_' + this.prefix, this.filters);
            this.appData.getAppData(data['data']['version']);
        });
    }

    onTableScroll(event, prefix) {
        console.log(event.target.scrollHeight, ' - ', event.target.scrollTop);
        if (event.target.scrollHeight - 500 < event.target.scrollTop) {
            // this.events.publish('nextPage' + prefix, {});
        }
    }

    tableButtonClick(tablePrefix, key, data) {
        this.events.publish("btnclick_" + tablePrefix, {'key': key, 'data': data});
//     'addFilter'
// }, {'quickFieldFilter':[{'field':'status', 'value':counter['status__id']}]})
    }

    saveField(sectionName, model, fieldData) {
        let filters = {'type': 'moving', 'name': 'taarif'};

        let newModel = {
            'main': {'value': model['id']['value'], 'updated': true, 'name': '', 'type': 'none'},
            'id': model['id']
        };

        newModel[fieldData['name']] = {
            'value': fieldData['value'],
            'name': fieldData['name'],
            'edited': true
        };
        //console.lognewModel);

        let tableData = {};
        tableData[sectionName] = [newModel];

        filters['editedSections'] = [sectionName];
        filters['sectionName'] = sectionName;

        let me = this;
        this.modelProvider.customPost('saveDataReport', [tableData], filters, true).then((data: any) => {
            // me.exTableData[me.sectionName + 'Data']['edited'] = false;
            // me.period['main']['updated'] = false;
            // me.fieldData['edited'] = false;
        });
    }

    // let me = this;
    //
    // this.refresh();
    //
    // this.events.subscribe('updatetaarif_' + this.prefix, (data) => {
    //     me.showMiniLoading = false;
    //     me.showLoading = false;
    //     //console.log'data!!');
    //     //console.logdata);
    //     me.onUpdate(data);
    //
    //     // if (!me.initialized) {
    //     me.initialized = true;
    //
    //     //     setTimeout(function () {
    //     //         me.refresh('all')
    //     //     }, 1);
    //     // } else {
    //     me.initializedFull = true;
    //     // }
    // });
    // this.events.subscribe('saveall' + this.prefix, (data) => {
    //     me.save();
    // });
    // this.events.subscribe('openMap', (data) => {
    //     //console.log'map opening');
    //     this.showOnMap(data);
    // });
    // this.events.subscribe('addEditedSections' + this.prefix, (data) => {
    //     if (this.editedSections.indexOf(data['key']) == -1) {
    //         this.editedSections.push(data['key']);
    //     }
    // });
    // this.events.subscribe('addEditedSections', (data) => {
    //     if (this.editedSections.indexOf(data['key']) == -1) {
    //         this.editedSections.push(data['key']);
    //     }
    // });
    // this.events.subscribe('qucikEditModelCall', (data) => {
    //     this.qucikEditModels.unshift(data['qucikEditModel']);
    //     this.qucikEditReady = false;
    //
    //     if (this.editedSections.indexOf(data['qucikEditModelKey']) == -1) {
    //         this.editedSections.push(data['qucikEditModelKey']);
    //     }
    //
    //     this.qucikEditModelKeys.unshift(data['qucikEditModelKey']);
    //
    //     let me = this;
    //     setTimeout(function () {
    //         me.qucikEditReady = true;
    //     }, 1);
    // });


    // this.events.subscribe(this.myprefix + '_updateFilter', (data) => {
    //     //console.logdata);
    //     this.searchFilter = data['search'];
    //     //console.logthis.searchFilter);
    // });

    // }

    // ngOnInit() {
    // this.events.subscribe('clickTableRow', (data) => {
    //     this.showRowModel = data['rowModel'];
    //     this.menuBoxesType = 3;
    // });
    //
    // this.events.subscribe('refresh_request_' + this.prefix, (filters) => {
    //     //add filters from sub models.
    //     for (let key in filters) {
    //         this.filters[key] = filters[key];
    //     }
    //     this.ready = true;
    // });

    // //from pages button
    // this.events.subscribe("markmodel", (data) => {
    //     this.removeSubModel(data.sectionKey, data.markType, data.id);
    // });
    //
    // this.events.subscribe("btnclick_" + this.prefix, (data) => {
    //     if (data == 'showTable') {
    //         this.showTable = !this.showTable;
    //     }
    // });
    // }

    // ngOnDestroy(): void {
    //     this.events.unsubscribe("btnclick_" + this.prefix);
    //     this.events.unsubscribe("clickrow");
    //     this.events.unsubscribe('updatetaarif_' + this.prefix);
    // }
    //
    // // back from update
    // onUpdate(data) {
    //     let me = this;
    //     me.tableDataFKeys = {};
    //     me.models = data.models;
    //     if (me.models && me.models.length > 0) //if error occured models len is 0.
    //     {
    //         if (!me.tableData) {
    //             me.tableData = me.models[0].data.finalResReport; //{'title': '', 'enableAdd':[]...}
    //             me.businessService.setAdminData(me.tableData);
    //         } else {
    //             for (let key in me.models[0].data.finalResReport) {
    //                 me.tableData[key] = me.models[0].data.finalResReport[key];
    //             }
    //         }
    //
    //         me.adminService.manageModels = me.tableData;
    //         // for (let key in me.models[0].data.finalResReport) {
    //         //     me.tableDataFKeys[key] = me.getValueKeys(key);
    //         // }
    //
    //         // if (!this.currentSectionKey) {
    //         //     this.currentSectionKey = me.tableData['showBoxes'][0][0];
    //         //     me.showSpecificRowIndex = 0;
    //         // }
    //
    //         // let currentSectionKey = this.currentSectionKey;
    //         // this.currentSectionKey = null;
    //         // me.showLoading = true;
    //         // setTimeout(function () {
    //         //     me.currentSectionKey = currentSectionKey;
    //         //     // setTimeout(function () {
    //         //         me.showLoading = false;
    //         //     // }, 1000);
    //         // });
    //         this.ready = true;
    //     }
    //
    //     //first init
    //     if (!this.menuBoxes) {
    //         this.menuBoxes = this.tableData['showBoxes'];
    //         //console.logthis.menuBoxes);
    //         //console.log"this.menuBoxes!!")
    //         this.menuBoxesType = 1;
    //     }
    //
    //     // this.ready = true;
    //     // this.ready = false;
    //     // setTimeout(function () {
    //     //     me.ready = true;
    //     // });
    //     this.events.publish("onTaarifUpdate", this.tableData);
    // }
    //
    // // get keys by object with field name as the key;
    // getValueKeys(tableKey) {
    //     let models = [];
    //     for (let i in this.tableData[tableKey]) {
    //
    //         if (tableKey.indexOf('Data') != -1) {
    //             continue;
    //         }
    //
    //         //model fields loop
    //         let model = {};
    //         for (let fieldKey in this.tableData[tableKey][i]) {
    //             //create tables data with keys of fields.
    //             //table row by fields names
    //             if (this.tableData[tableKey][i][fieldKey].type == 'table') {
    //
    //                 let keyFields = [];
    //
    //                 for (let rowIndex in this.tableData[tableKey][i][fieldKey].data) {
    //                     let rowKeyFields = {};
    //
    //                     for (let sfield in this.tableData[tableKey][i][fieldKey].data[rowIndex]) {
    //                         rowKeyFields[this.tableData[tableKey][i][fieldKey].data[rowIndex][sfield].name] = this.tableData[tableKey][i][fieldKey].data[rowIndex][sfield];
    //                     }
    //                     keyFields.push(rowKeyFields);
    //                 }
    //
    //                 this.tableData[tableKey][i][fieldKey].dataFkeys = keyFields;
    //             }
    //
    //             //field in object by name
    //             model[this.tableData[tableKey][i][fieldKey].name] = this.tableData[tableKey][i][fieldKey];
    //
    //         }
    //         models.push(model);
    //     }
    //     return models;
    // }
    //
    // showEdit(sectionKey) {
    //     if (!this.initializedFull) {
    //         return;
    //     }
    //
    //     // //console.logsectionKey);
    //     if (this.tableData[sectionKey + 'Data'] && this.tableData[sectionKey + 'Data']['type'] == 'calendar') {
    //         this.showCalendar = true;
    //     } else if (this.tableData[sectionKey].length > 1) {
    //         // skip -1 show real model data
    //         this.showSpecificRowIndex = 1;
    //         // this.tableData[sectionKey][1][0]['updated'] = true;
    //
    //     } else {
    //         //only if it is empty
    //         //show -1 - first row to add
    //         this.showSpecificRowIndex = 0;
    //         this.tableData[sectionKey][0][0]['value'] = null;
    //     }
    //
    //     this.currentSectionKey = sectionKey;
    //
    //     if (this.editedSections.indexOf(sectionKey) == -1) {
    //         this.editedSections.push(sectionKey);
    //     }
    //     // //console.logthis.tableData);
    //     //
    //     // //console.logthis.tableData[this.currentSectionKey][0][0]['value']);
    //
    //     //
    //     // get new data?
    //     // if (!this.tableData[this.currentSectionKey] ||
    //     //     (this.tableData[this.currentSectionKey].length == 1 && (this.tableData[this.currentSectionKey][0][0]['value'] == -1 || !this.tableData[this.currentSectionKey][0][0]['value'])) ||
    //     //     this.tableData[this.currentSectionKey].length == 0) {
    //     //     this.refresh(this.currentSectionKey);
    //     // }
    //     //
    //     //
    //
    //     // this.ionContent.scrollToTop(300);
    //
    //     //add all rows if no tables fields
    //     // if (!this.tableData[sectionKey + 'TableFieldsOrder']) {
    //     //     this.showSpecificRows = [];
    //     //     for (let i in this.tableData[sectionKey]) {
    //     //         this.showSpecificRows.push(this.tableData[sectionKey][i]);
    //     //     }
    //     // }
    // }
    //
    //
    // save() {
    //     let me = this;
    //
    //     //console.log'this.editedSections!');
    //     //console.logthis.editedSections);
    //     //console.logthis.tableData);
    //
    //     this.filters = {'ordering': '-id', 'type': 'moving', 'name': 'taarif', 'modelOffset': 0, 'modelLimit': 20};
    //
    //     this.filters['editedSections'] = this.editedSections;
    //     let tableData = {};
    //     for (let key of this.editedSections) {
    //         tableData[key] = this.tableData[key];
    //         tableData[key + '_removeIds'] = this.tableData[key + '_removeIds'];
    //     }
    //
    //     this.modelProvider.customPost('saveDataReport', [tableData], this.filters, true).then((data: any) => {
    //         // this.events.publish('refresh_request_' + this.prefix, this.filters);
    //         data = data['data'];
    //
    //         // for (let key in data) {
    //         //     this.tableData[key] = data[key];
    //         // }
    //
    //         //remove remove ids
    //         for (let key in this.tableData) {
    //             if (key.indexOf('removeIds') != -1)
    //                 this.tableData[key] = [];
    //         }
    //         //
    //         // let currentSectionKey = this.currentSectionKey;
    //         // this.currentSectionKey = null;
    //         // let me = this;
    //         // setTimeout(function () {
    //         //     me.currentSectionKey = currentSectionKey;
    //         //     // setTimeout(function () {
    //         //         me.showLoading = false;
    //         //     // }, 1000);
    //         // });
    //         // this.qucikEditModelKeys = [];
    //         // this.editedSections = [];
    //         // this.qucikEditReady = false;
    //         // this.showRowModel = null;
    //         // this.menuBoxesType = 2;
    //
    //         // this.ready = false;
    //         // setTimeout(function () {
    //         //     me.ready = true;
    //         // });
    //     });
    // }
    //
    // updateData() {
    //     this.tableData['extraData']['updatedData'] = false;
    //
    //     this.filters['editedSections'] = [];
    //     this.filters['sectionName'] = '';
    //     this.filters['updateData'] = true;
    //     this.filters['updateModelClasses'] = true;
    //     this.modelProvider.customPost('saveDataReport', [this.tableData], this.filters, true).then((data: any) => {
    //         this.events.publish('refresh_request_' + this.prefix, this.filters);
    //     });
    // }
    //
    // //simple remove
    // removeRModel(sectionKey, model) {
    //     this.removeSubModel(sectionKey, 'removeIds', model[0]['value']);
    // }
    //
    // removeSubModel(sectionKey, markType, id) {
    //     if (!this.tableData[sectionKey + '_' + markType])
    //         this.tableData[sectionKey + '_' + markType] = [];
    //
    //     if (this.tableData[sectionKey + '_' + markType].indexOf(id) == -1) {
    //         this.tableData[sectionKey + '_' + markType].push(id);
    //     } else {
    //         this.tableData[sectionKey + '_' + markType].splice(this.tableData[sectionKey + '_' + markType].indexOf(id), 1);
    //     }
    //     this.editedSections.push(sectionKey);
    // }
    //
    // removeModel(model, secKey, markTypeKey, id) {
    //
    //     //it array by we can set it with key as well..
    //     model.removed = !!!model.removed;
    //
    //     // for (let key in model) {
    //     //     if (model[key]['name'] == 'id')
    //     //         model[key]['removed'] = !!!model[key]['removed'];
    //     // }
    //
    //     this.markSubModel(secKey, 'removed', id);
    // }
    //
    //
    // markSubModel(seckey, markTypeKey, id) {
    //     if (!this.tableData[seckey + "_" + markTypeKey]) {
    //         this.tableData[seckey + "_" + markTypeKey] = [];
    //     }
    //
    //     if (this.tableData[seckey + "_" + markTypeKey].indexOf(id) !== -1) {
    //         this.tableData[seckey + "_" + markTypeKey].splice(this.tableData[seckey][markTypeKey].indexOf(id), 1);
    //     } else {
    //         this.tableData[seckey + "_" + markTypeKey].push(id);
    //     }
    // }
    //
    // addModel(sectionKey, fieldDataName = null) {
    //     let newModel = JSON.parse(JSON.stringify(this.tableData[sectionKey][0]));
    //
    //     //remove id for new model copied.
    //     for (let key in newModel) {
    //         if (newModel[key]['name'] == 'id')
    //             newModel[key]['value'] = null;
    //     }
    //
    //     this.tableData[sectionKey].unshift(newModel);
    //     this.tableDataFKeys[sectionKey] = this.getValueKeys(sectionKey);
    // }
    //
    // addSubModel(fieldData) {
    //     let newModel = JSON.parse(JSON.stringify(fieldData.data[0]));
    //     newModel[0] = null;
    //
    //     fieldData.data.unshift(newModel);
    // }
    //
    // saveMiniField(sectionKey, fieldDataName, modelIndex, rowIndex, y, colVal) {
    //     //table field - data is set
    //     this.tableDataFKeys[sectionKey][modelIndex][fieldDataName].data[rowIndex][y] = colVal;
    // }
    //
    // filterit(modeldata) {
    //     this.filters[modeldata['filterkey']] = modeldata['value'];
    //     this.events.publish('refresh_request_' + this.prefix, this.filters);
    // }
    //
    // refresh(sectionKey = null) {
    //     this.showMiniLoading = true;
    //     this.tableData = null;
    //
    //     // let filters = {
    //     //     'clearFilters': true,
    //     //     'keepFilters': ['taarif']
    //     // };
    //     //
    //     // if (sectionKey) {
    //     //     filters['sectionName'] = sectionKey;
    //     // }
    //
    //     this.ready = false;
    //     // this.events.publish('refresh_request_' + this.prefix,
    //     //     filters);
    //     let me = this;
    //     this.modelProvider.list('report', this.filters).then(function (data: any) {
    //         ////console.logres);
    //         me.onUpdate(data);
    //     });
    // }
    //
    // back() {
    //     this.showCalendar = false;
    //
    //     this.menuBoxesType--;
    //     if (this.menuBoxesType == 1) {
    //         this.menuBoxes = this.tableData['showBoxes'];
    //     }
    //
    //     if (this.showRowModel) {
    //         this.events.publish('clickTableRowBack', {});
    //         this.showRowModel = null;
    //     } else {
    //         this.currentSectionKey = null;
    //     }
    // }
    //
    // showCategory(menuIndex, subIndex = 0) {
    //     let params = {
    //         'sectionName': this.tableData['showBoxes'][menuIndex][subIndex],
    //         'menuIndex': menuIndex,
    //         'subIndex': subIndex,
    //     };
    //
    //     let navigationExtras: NavigationExtras = {
    //         queryParams: params
    //     };
    //
    //     this.navCtrl.navigateForward('admin-model/' + this.tableData['showBoxes'][menuIndex][subIndex], navigationExtras);
    // }
    //
    // getImageBacground(imgName) {
    //     if (this.tableData['showBoxesImagesBase']) {
    //         return "url('" + this.tableData['showBoxesImagesBase'] + imgName + "')";
    //     }
    //     return '';
    // }
    //
    // customEvent(key) {
    //     this.navCtrl.navigateForward(key);
    // }
    //
    // showOnMap(data) {
    //
    //     this.mapOpen = true;
    // }
    //
    // closePopup() {
    //     this.qucikEditModelKeys.shift();
    //     this.qucikEditModels.shift();
    //     this.qucikEditReady = false;
    //
    //     if (this.qucikEditModelKeys.length > 0) {
    //         let me = this;
    //         setTimeout(function () {
    //             me.qucikEditReady = true;
    //         });
    //     }
    // }


}
